import React from "react";
import { useNavigate } from "react-router-dom";
import { Stack, Typography } from "@mui/material";
import BottomButton from "./BottomButton";

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <>
            <Stack
                justifyContent="center"
                alignItems="center"
                height="100%"
                textAlign="center"
                spacing={5}
                paddingX={2}
            >
                <Typography variant="h4" fontWeight={700}>
                    Oops! You’re lost. 🧭
                </Typography>
                <Typography variant="body1">
                    Looks like you took a wrong turn. Let’s get you back on
                    track!
                </Typography>
            </Stack>
            <BottomButton sticky onClick={() => navigate("/")}>
                🏠 Take Me Home
            </BottomButton>
        </>
    );
};

export default NotFound;
